import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import { Direction, InteractionType, } from '@debbie/common/dist/interactions/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Inbox } from '../Icons/index.js';
import MessageCircle from '../Icons/MessageCircle.js';
import EmailInteraction from './EmailInteraction.js';
import NoteInteraction from './NoteInteraction.js';
import RecipientContent from './RecipientContent.js';
const CaseCreditor = (props) => {
    const { caseId, id } = props.case;
    const lang = useSelector((s) => s.lang);
    const usersLoadable = useUsers();
    const users = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const creditorLoadable = useCreditor(props.case?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const collectorLoadable = useCollector((props.case &&
        creditor &&
        getCollectorOnCase(props.case.type, props.case.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const user = creditor && users && users.find((u) => u.id === creditor?.contactId);
    const emailTo = user && user.email;
    const tabs = [
        {
            children: (React.createElement(NoteInteraction, { referenceId: caseId, referenceType: Entity.Case, id: id, options: {
                    direction: Direction.OUTGOING,
                    type: InteractionType.ClientNote,
                }, sendButtonText: lang.interactions.send })),
            icon: MessageCircle,
            label: lang.interactionTypes['CLIENT NOTE'],
        },
        {
            children: (React.createElement(EmailInteraction, { referenceId: caseId, referenceType: Entity.Case, emailTo: emailTo })),
            icon: Inbox,
            label: lang.interactionTypes.EMAIL,
            shouldHide: !(emailServer && emailTo),
        },
    ];
    return React.createElement(RecipientContent, { tabs: tabs });
};
export default CaseCreditor;
//# sourceMappingURL=CaseCreditor.js.map